export const numberComparisonInequalityOperators = [
  "lessThan",
  "greaterThan",
] as const;

export type NumberComparisonInequalityOperator =
  (typeof numberComparisonInequalityOperators)[number];

export const numberComparisonOperators = [
  ...numberComparisonInequalityOperators,
  "equalTo",
  "notEqualTo",
] as const;

export type NumberComparisonOperator =
  (typeof numberComparisonOperators)[number];
